<div
  class="ioh-actions"
  [ngClass]="
    iohShowFilter() && iohLevelLabel() !== 'level-1'
      ? 'on-ioh-filter-action'
      : ''
  "
>
  <p-selectbutton
    id="levelToggle"
    [ngModel]="iohLevelLabel()"
    [options]="iohStateOptions"
    (onOptionClick)="onLevelChange($event)"
    optionLabel="label"
    optionValue="value"
    [allowEmpty]="false"
  >
    <ng-template let-option #item>
      <ng-container [ngSwitch]="option.label">
        <span *ngSwitchCase="'Level 1'">
          {{ iohLevelLabel() === 'level-1' ? option.label : option.icon }}
        </span>
        <span *ngSwitchCase="'Level 2'">
          {{ iohLevelLabel() === 'level-2' ? option.label : option.icon }}
        </span>

        <span *ngSwitchCase="'Map'">
          <i class="pi pi-globe"></i>
          {{ iohLevelLabel() === 'level-3' ? 'Map' : '' }}
        </span>

        <!-- fallback (should never happen) -->
        <span *ngSwitchDefault>{{ option.label }}</span>
      </ng-container>
    </ng-template>
  </p-selectbutton>

  <p-inputGroup *ngIf="level === 2">
    <div
      class="ioh-label-action-container"
      [pTooltip]="
        !isIohShowLabelSwitchEnabled()
          ? 'Show Labels disabled due to URL filters'
          : ''
      "
      tooltipPosition="left"
    >
      <div class="label-name">Show Labels</div>
      <p-toggleswitch
        [ngModel]="iohTrainLabelsShow()"
        (ngModelChange)="iohTrainLabelsShow.set($event)"
        (click)="onTrainLabelChange($event)"
        [disabled]="!isIohShowLabelSwitchEnabled()"
      ></p-toggleswitch>
    </div>
  </p-inputGroup>
  <p-button
    class="level-ioh-action-button"
    (click)="iohCollapseAll()"
    *ngIf="level === 1 || level === 0"
  >
    <div class="ioh-collapse-all-icon"></div>
    <div class="fs-12">Collapse All</div>
  </p-button>
  <p-inputGroup *ngIf="level === 1">
    <div style="display: flex">
      <button
        type="button"
        pButton
        icon="pi pi-plus"
        [disabled]="iohZoomLevel() === 1.5"
        class="ioh-plus-button"
        (click)="handleZoom('+')"
      ></button>
      <div class="ioh-zoom-label fs-12">
        {{ (iohZoomLevel() * 100).toFixed(0) }}%
      </div>
      <button
        type="button"
        pButton
        icon="pi pi-minus"
        [disabled]="iohZoomLevel() === miniohZoomLevel()"
        class="ioh-minus-button"
        (click)="handleZoom('-')"
      ></button>
    </div>
  </p-inputGroup>
  <p-button class="level-ioh-action-button ioh-feedback-button">Feedback</p-button>
</div>
<p-contextMenu
  [model]="iohItems()"
  styleClass="menucus ioh"  [appendTo]="'body'"
  #iohcm
></p-contextMenu>

<div
  class="ioh-level-wrapper"
  (contextmenu)="onContextMenuClick($event, iohcm)"
  #iohlevelSchematic
  id="ioh-level-wrapper-id"
  [ngStyle]="level === 1 ? { padding: '40px 0px 0px 40px' } : {}"
>
  <ioh-level-one-dashboard
    *ngIf="level === 0"
    [terminals]="terminals"
    [level]="level"
    [iohShowFilter]="iohShowFilter()"
    [iohEquipmentInfo]="iohEquipmentInfo()"
    [iohGateInfo]="iohGateInfo()"
    [iohTrainInfo]="iohTrainInfo()"
    [iohNetworkStats]="iohAppService.iohNetworkStats$()"
    (headerClick)="terminalClicked($event)"
    (bodyClick)="generateContextMenuItem()"
  ></ioh-level-one-dashboard>

  <div
    *ngIf="false"
    id="ioh-level-container-ID"
    appDraggable
    class="ioh-level-container level-one-background"
    [style.zoom]="iohZoomLevel()"
    #iohNetworkSchematic
  >
    <ioh-level-one-svg
      (corridorChange)="iohCorridorClicked($event)"
    ></ioh-level-one-svg>
    <ng-container>
      <ng-container *ngFor="let terminal of terminals">
        <div
          class="ioh-terminal-container"
          #terminal
          [style.left.px]="terminal.terminalPosition.startX"
          [style.top.px]="terminal.terminalPosition.startY - 25"
        >
          <div
            class="ioh-terminal-name cursor-pointer"
            (click)="terminalClicked(terminal)"
          ></div>
          <div
            class="ioh-terminal-equipment cursor-pointer"
            (click)="showEquipmentInfo(terminal)"
          >
            <span
              [ngStyle]="{ fontSize: iohDynamicFontSize() }"
              class="bg-success"
              >{{
                getEquipmentTableInfo(terminal?.name)?.totalActiveCount || 0
              }}</span
            >
            <span class="seperator">/</span>
            <span
              class="bg-danger"
              [ngStyle]="{ fontSize: iohDynamicFontSize() }"
              >{{
                getEquipmentTableInfo(terminal?.name)?.totalOfflineCount || 0
              }}</span
            >
          </div>
          <div
            class="ioh-terminal-train cursor-pointer"
            (click)="showTrainInfo(terminal)"
          >
            <span
              [ngStyle]="{ fontSize: iohDynamicFontSize() }"
              class="bg-success"
              >{{
                iohTrainInfo() && iohTrainInfo().terminals?.[terminal.milepost]?.inboundTrains?.length || 0
              }}</span
            >
            <span class="seperator">/</span>
            <span
              class="bg-danger"
              [ngStyle]="{ fontSize: iohDynamicFontSize() }"
              >{{
                 iohTrainInfo() && iohTrainInfo().terminals?.[terminal.milepost]?.outboundTrains?.length || 0
              }}</span
            >
          </div>
           <div
            class="ioh-terminal-gate cursor-pointer"
            (click)="showGateInfo(terminal)"
          >
            <span
              [ngStyle]="{ fontSize: iohDynamicFontSize }"
              [ngClass]="(iohGateInfo()?.terminals?.[getTerminalCode(terminal.code)]?.avgTurnTimeMinutes > env.appConfig.iohGateAvgTurnTimeMints) ? 'bg-danger' : 'bg-success'"
              >{{(iohGateInfo()?.terminals?.[getTerminalCode(terminal.code)]?.avgTurnTimeMinutes) || 0}}</span
            >
          </div>
          @if (terminal.showEquipmentInfo) {
          <ioh-csx-terminal-equipment
            [terminalName]="terminal.name"
            [terminalAbbreviation]="terminal.code"
            [trains]="terminal.awaitingDepartureTrains"
            [terminalTrains]="terminal.trainAwaitingDeparture"
            [terminalMetric]="terminal.terminalMetric"
            [showClose]="true"
            [(close)]="terminal.showEquipmentInfo"
            [level]="level"
            [terminalUid]="terminal.schematicId + '-equipment'"
            (closeChange)="handleClose()"
            [showFilter]="iohShowFilter()"
            [equipmentResponse]="iohEquipmentInfo()"
          ></ioh-csx-terminal-equipment>
          } @if (terminal.showGateInfo) {
          <ioh-csx-terminal-gate
            [terminalName]="terminal.name"
            [terminalAbbreviation]="getTerminalCode(terminal.code)"
            [showClose]="true"
            [(close)]="terminal.showGateInfo"
            [level]="level"
            [terminalUid]="terminal?.schematicId + '-gate'"
            (closeChange)="handleClose()"
            [showFilter]="showFilter"
            [gateResponse]="iohGateInfo()?.terminals?.[getTerminalCode(terminal.code)]"
          ></ioh-csx-terminal-gate>
          }@if (terminal.showTrainInfo) {
          <ioh-csx-terminal-train
            [terminalName]="terminal.name"
            [terminalAbbreviation]="terminal.code"
            [trains]="terminal.awaitingDepartureTrains"
            [terminalTrains]="terminal.trainAwaitingDeparture"
            [terminalMetric]="terminal.terminalMetric"
            [showClose]="true"
            [(close)]="terminal.showTrainInfo"
            [level]="level"
            [terminalUid]="terminal?.schematicId + '-train'"
            [showFilter]="iohShowFilter()"
            (closeChange)="handleClose()"
            [trainResponse]="iohTrainInfo() && iohTrainInfo().terminals?.[terminal.milepost]"
          ></ioh-csx-terminal-train>
          }
        </div>
      </ng-container>
    </ng-container>
  </div>

  <div
    class="ioh-level-map-container"
    [style.zoom]="iohZoomLevel()"
    appDraggable
    *ngIf="level === 1"
  >
    <ioh-level-two-svg (corridorChange)="iohCorridorClicked($event)">
    </ioh-level-two-svg>
    <ng-container>
      <ng-container *ngFor="let terminal of terminals">
        <div
          class="ioh-terminal-container"
          #terminal
          [style.left.px]="terminal.terminalPosition.startX"
          [style.top.px]="terminal.terminalPosition.startY - 25"
        >
          @if (terminal.showNearByTrains || iohTrainIdForSearch()) {
          <csx-ioh-trains-table
            [trains]="terminal.nearByTrains"
            [showClose]="true"
            [(close)]="terminal.showNearByTrains"
            (iohMoreEvent)="iohMoreCliked($event, terminal)"
            (iohCloseChange)="iohHandleTableClose()"
            [level]="level"
            [left]="
              nearByTrainPosistionTable[terminal.nearByTrainsDirection - 1].x
            "
            [top]="
              nearByTrainPosistionTable[terminal.nearByTrainsDirection - 1].y
            "
            [iohTrainIdForSearch]="iohTrainIdForSearch()"
          ></csx-ioh-trains-table>
          }
          <div
            *ngIf="terminal.uid && terminal.nearByTrains.length > 0"
            class="train-count-near-by-termianl"
            [ngClass]="'train-count-near-by-terminal-background-color'"
            [style.left.px]="
              nearByTrainPosistionInfo[terminal.nearByTrainsDirection - 1].x
            "
            [style.top.px]="
              nearByTrainPosistionInfo[terminal.nearByTrainsDirection - 1].y
            "
            [style.rotate.deg]="
              nearByTrainPosistionInfo[terminal.nearByTrainsDirection - 1]
                .rotation
            "
            (click)="showNearByTrains(terminal)"
            [ngStyle]="{ fontSize: iohDynamicFontSize() }"
          >
            <label
              [style.rotate.deg]="
                -nearByTrainPosistionInfo[terminal.nearByTrainsDirection - 1]
                  .rotation
              "
            >
              {{ terminal.nearByTrains.length }}
            </label>
          </div>
          <div
            class="ioh-terminal-name" 
            [ngClass]="!isIohJunction(terminal) ? 'cursor-pointer' : ''"
            (click)="terminalClicked(terminal)"
          ></div>

          <div
            *ngIf="!isIohJunction(terminal)"
            class="ioh-terminal-gate l2 cursor-pointer"
            (click)="showGateInfo(terminal, $event)"
          >
            <span
              [ngStyle]="{ fontSize: iohDynamicFontSize }"
              [ngClass]="(iohGateInfo()?.terminals?.[getTerminalCode(terminal.code)]?.avgTurnTimeMinutes > env.appConfig.iohGateAvgTurnTimeMints) ? 'bg-danger' : 'bg-success'"
              >{{(iohGateInfo()?.terminals?.[getTerminalCode(terminal.code)]?.avgTurnTimeMinutes) || 0}}</span
            >
          </div>

          <div
            *ngIf="!isIohJunction(terminal)"
            class="ioh-terminal-equipment l2 cursor-pointer"
            (click)="showEquipmentInfo(terminal, $event)"
          >
            <span
              [ngStyle]="{ fontSize: iohDynamicFontSize() }"
              class="bg-success"
              >{{
                getEquipmentTableInfo(terminal?.name)?.totalActiveCount || 0
              }}</span
            >
            <span class="seperator">/</span>
            <span
              class="bg-danger"
              [ngStyle]="{ fontSize: iohDynamicFontSize() }"
              >{{
                getEquipmentTableInfo(terminal?.name)?.totalOfflineCount || 0
              }}</span
            >
          </div>
          <div
            *ngIf="!isIohJunction(terminal)"
            class="ioh-terminal-train l2 cursor-pointer"
            (click)="showTrainInfo(terminal, $event)"
          >
            <span
              [ngStyle]="{ fontSize: iohDynamicFontSize() }"
              class="bg-success"
              >{{
                iohTrainInfo() && iohTrainInfo().terminals?.[terminal.milepost]?.inboundTrains?.length || 0
              }}</span
            >
            <span class="seperator">/</span>
            <span
              class="bg-danger"
              [ngStyle]="{ fontSize: iohDynamicFontSize() }"
              >{{
                 iohTrainInfo() && iohTrainInfo().terminals?.[terminal.milepost]?.outboundTrains?.length || 0
              }}</span
            >
          </div>
          @if (terminal.showEquipmentInfo) {
          <ioh-csx-terminal-equipment
            [terminalName]="terminal.name"
            [terminalAbbreviation]="terminal.code"
            [showClose]="true"
            [(close)]="terminal.showEquipmentInfo"
            [level]="level"
            [terminalUid]="terminal.schematicId + '-equipment'"
            [showFilter]="iohShowFilter()"
            [equipmentResponse]="iohEquipmentInfo()"
            [clickPoint]="terminal.popupClickPoint"
            [bounds]="terminal.popupBounds"
            (closeChange)="handleClose()"
          ></ioh-csx-terminal-equipment>
          } @if (terminal.showGateInfo) {
          <ioh-csx-terminal-gate
            [terminalName]="terminal.name"
            [terminalAbbreviation]="getTerminalCode(terminal.code)"
            [showClose]="true"
            [(close)]="terminal.showGateInfo"
            [level]="level"
            [terminalUid]="terminal?.schematicId + '-gate'"
            (closeChange)="handleClose()"
            [showFilter]="showFilter"
            [gateResponse]="iohGateInfo()?.terminals?.[getTerminalCode(terminal.code)]"
            [clickPoint]="terminal.popupClickPoint"
            [bounds]="terminal.popupBounds"
          ></ioh-csx-terminal-gate>
          } @if (terminal.showTrainInfo) {
          <ioh-csx-terminal-train
            [terminalName]="terminal.name"
            [terminalAbbreviation]="terminal.code"
            [showClose]="true"
            [(close)]="terminal.showTrainInfo"
            [level]="level"
            (closeChange)="handleClose()"
            [terminalUid]="terminal?.schematicId + '-train'"
            [showFilter]="iohShowFilter()"
            [trainResponse]="iohTrainInfo() && iohTrainInfo().terminals?.[terminal.milepost]"
            [clickPoint]="terminal.popupClickPoint"
            [bounds]="terminal.popupBounds"
          ></ioh-csx-terminal-train>
          }
        </div>
      </ng-container>
    </ng-container>
    @for (corridor of corridors(); track corridor) {
    <csx-ioh-trains-table
      [trains]="corridor.trains"
      [left]="corridor.tablePosition.startX"
      [top]="corridor.tablePosition.startY"
      [arrowDirection]="corridor.arrowDirection"
      [showCount]="corridor.showCount"
      [level]="level"
      (iohMoreEvent)="iohMoreCliked($event)"
      (iohCloseChange)="iohHandleTableClose()"
      [iohCollapseAll]="iohCollapseAllData()"
      [iohTrainIdForSearch]="iohTrainIdForSearch()"
    ></csx-ioh-trains-table>
    }
  </div>

  <div *ngIf="level === 2" class="ioh-level3-map-slot" #level3MapSlot></div>
</div>

<p-toast
  key="missingIOHTrain"
  position="top-center"
  class="intermodal-custom-toast"
/>
